export default "__VITE_ASSET__BNZm8UOs__"